import router from './index.js'
import store from '../store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import cookie from 'js-cookie'
import { authRouterList } from '@/router/routerList.js'

// 白名单
const whiteRouter = [
  '404',
  'modifyGrade',
  'modifyFeedback',
  'modifyBasicGrades',
  'modifyQuizGrades'
]

router.beforeEach((to, from, next) => {
  NProgress.start()
  console.log(store.getters.routerList)
  // return false
  const shuangchuanginfo = localStorage.getItem('shuangchuanginfo')
  if (whiteRouter.includes(to.name)) {
    next()
  } else {
    if (!cookie.get('token') || !shuangchuanginfo) {
      // 清空信息
      localStorage.clear()
      cookie.remove('token')
      if (store.getters.userId) {
        window.location.reload()
      } else {
        if (to.name === 'login') {
          next()
        } else {
          next({
            name: 'login'
          })
        }
      }
    } else {
      if (!store.getters.userId) {
        store.commit('SET_USERINFO', JSON.parse(shuangchuanginfo))
        //权限，筛选路由后导入
        //防止页面刷新，vuex的数据消失
        store.commit(
          'DETAILNAME',
          localStorage.getItem('detailSchoolName')
            ? localStorage.getItem('detailSchoolName')
            : ''
        )
        store
          .dispatch('initRouterListIndexRouter', {
            routerList: authRouterList,
            roleList: store.getters.roleList
          })
          .then(() => {
            router.addRoutes(store.getters.routerList)
            next({ ...to })
          })
      } else {
        if (to.name === 'login') {
          next({ name: store.getters.indexRouter })
          NProgress.done()
        } else {
          store
            .dispatch('filterCategoryRouter', {
              rightName: to.meta.rightName,
              roleList: store.getters.roleList,
              category: to.meta.category
            })
            .then(allCategoryRouterList => {
              if (to.name === 'home') {
                next()
              } else {
                let haveItem = false
                for (const item of allCategoryRouterList) {
                  if (to.name === item.name) {
                    haveItem = true
                  }
                }

                if (haveItem) {
                  let haveRouter = ''
                  for (const item of store.getters.categoryRouterList) {
                    if (to.name === item.name) {
                      haveRouter = true
                    }
                  }
                  if (haveRouter) {
                    next()
                  } else {
                    next({ name: store.getters.categoryRouterList[0].name })
                  }
                } else {
                  next()
                }
              }
            })
        }
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
